/* pl-video-slide — o vídeo do produto toca DENTRO da galeria no celular (18/10/2026).

   Pedido do Diogo, vendo no iPhone: o toque no vídeo da galeria abria o modal por cima da página ("uma nova
   tela"); no app o vídeo toca ali mesmo. Agora, com toque (celular e tablet), o player da YouTube nasce dentro do
   próprio slide (snippets/pl-video-slide.liquid). No computador nada muda: o clique abre o modal de sempre.

   O DEDO: um iframe da YouTube engole todos os toques. Se ele ficasse por cima, o dedo não passaria mais para a
   próxima foto (o carrossel da agência só ouve toque fora do iframe). Por isso o player fica EMBAIXO do botão do
   slide, que continua sendo a camada de toque: arrastar passa a foto; tocar pausa e volta a tocar, por comando ao
   player (postMessage, enablejsapi=1). Os controles da YouTube ficam desligados (controls=0): não dá para alcançá-los.

   SOM: o navegador do celular só deixa o vídeo começar sozinho SEM som (mute=1). O botão de alto-falante manda o
   unMute DENTRO do toque, e o navegador repassa o toque ao player junto com a mensagem.

   Sair do slide pausa na hora e desmonta o player quando a passada termina (iframe parado no meio da trilha pesa
   na passada das fotos). Rolar a página até a galeria sumir também pausa. O vídeo terminou: volta a capa.
*/
(function () {
  'use strict';
  if (window.plVideoSlide) return; // o snippet pode sair duas vezes (dois vídeos)
  window.plVideoSlide = true;

  var TOQUE = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  var YT = 'https://www.youtube.com';
  var atual = null; // slide com player montado (um por vez)

  var visao =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (vistos) {
            vistos.forEach(function (v) {
              var p = v.target.plPlayer;
              if (!v.isIntersecting && p && p.estado === 1) pausar(v.target);
            });
          },
          { threshold: 0.25 }
        )
      : null;

  function comando(p, func, args) {
    try {
      p.iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: args || [] }), YT);
    } catch (e) {
      /* o iframe ainda está em about:blank */
    }
  }

  function pintar(slide) {
    var p = slide.plPlayer;
    var tocando = !!p && p.estado === 1;
    slide.classList.toggle('is-montado', !!p);
    slide.classList.toggle('is-carregando', !!p && !p.comecou);
    slide.classList.toggle('is-tocando', tocando);
    slide.classList.toggle('is-pausado', !!p && p.comecou && !tocando);
    var abrir = slide.querySelector('.pl-video-slide__abrir');
    if (abrir) {
      abrir.setAttribute('aria-label', !p ? abrir.dataset.rotulo || 'Assistir ao vídeo' : tocando ? 'Pausar o vídeo' : 'Tocar o vídeo');
    }
    var som = slide.querySelector('.pl-video-slide__som');
    if (som) {
      var ligado = !!p && !p.mudo;
      som.hidden = !p;
      som.setAttribute('aria-pressed', ligado ? 'true' : 'false');
      som.setAttribute('aria-label', ligado ? 'Desligar o som' : 'Ligar o som');
    }
  }

  function desmontar(slide) {
    var p = slide.plPlayer;
    if (!p) return;
    window.removeEventListener('message', p.ouvir);
    p.timers.forEach(function (t) {
      window.clearInterval(t);
      window.clearTimeout(t);
    });
    if (visao) visao.unobserve(slide);
    p.iframe.remove(); // remover é o que para o vídeo e o som
    slide.plPlayer = null;
    if (atual === slide) atual = null;
    pintar(slide);
  }

  function montar(slide) {
    var id = slide.dataset.plVideo;
    if (!id) return;
    if (atual && atual !== slide) desmontar(atual);

    var p = { estado: -1, mudo: true, comecou: false, ouviu: false, timers: [] };
    p.iframe = document.createElement('iframe');
    p.iframe.className = 'pl-video-slide__iframe';
    p.iframe.title = 'Vídeo do produto';
    p.iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    p.iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    p.iframe.tabIndex = -1; // quem controla são os botões do slide
    p.iframe.src =
      YT +
      '/embed/' +
      id +
      '?' +
      [
        'autoplay=1',
        'mute=1', // sem isso o celular não deixa começar sozinho
        'playsinline=1', // sem isso o iPhone joga no player nativo, em tela cheia
        'controls=0', // ficariam embaixo da camada de toque
        'rel=0',
        'iv_load_policy=3',
        'enablejsapi=1',
        'origin=' + encodeURIComponent(window.location.origin)
      ].join('&');

    p.ouvir = function (e) {
      if (e.source !== p.iframe.contentWindow) return;
      var d = e.data;
      if (typeof d === 'string') {
        try {
          d = JSON.parse(d);
        } catch (x) {
          return;
        }
      }
      if (!d || !d.event) return;
      p.ouviu = true;
      var estado;
      if (d.event === 'onStateChange') estado = d.info;
      else if ((d.event === 'infoDelivery' || d.event === 'initialDelivery') && d.info) {
        estado = d.info.playerState;
        if (typeof d.info.muted === 'boolean') p.mudo = d.info.muted;
      }
      if (typeof estado === 'number') {
        if (estado === 0) {
          desmontar(slide); // terminou: volta a capa
          return;
        }
        p.estado = estado;
        if (estado === 1) p.comecou = true;
      }
      pintar(slide);
    };
    window.addEventListener('message', p.ouvir);

    // aperto de mão do embed: repete até o player responder (no máximo 10 s); depois ele avisa cada troca
    var tentativas = 0;
    var aperto = window.setInterval(function () {
      if (p.ouviu || ++tentativas > 50) {
        window.clearInterval(aperto);
        return;
      }
      try {
        p.iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: id, channel: 'widget' }), YT);
      } catch (e) {
        /* a próxima volta pega */
      }
    }, 200);
    p.timers.push(aperto);
    // não começou em 8 s (autoplay barrado, ex.: modo de economia de energia do iPhone): mostra o vídeo parado
    // com o botão de play, e o toque manda playVideo
    p.timers.push(
      window.setTimeout(function () {
        if (!p.comecou) {
          p.comecou = true;
          pintar(slide);
        }
      }, 8000)
    );

    slide.insertBefore(p.iframe, slide.firstChild); // embaixo da camada de toque
    slide.plPlayer = p;
    atual = slide;
    if (visao) visao.observe(slide);
    pintar(slide);
  }

  function pausar(slide) {
    var p = slide.plPlayer;
    comando(p, 'pauseVideo');
    p.estado = 2;
    pintar(slide);
  }

  function tocarOuPausar(slide) {
    var p = slide.plPlayer;
    if (p.estado === 1) {
      pausar(slide);
      return;
    }
    comando(p, 'playVideo');
    p.comecou = true;
    pintar(slide);
  }

  function alternarSom(slide) {
    var p = slide.plPlayer;
    if (!p) return;
    if (p.mudo) {
      comando(p, 'unMute');
      comando(p, 'setVolume', [100]);
      if (p.estado !== 1) comando(p, 'playVideo');
    } else {
      comando(p, 'mute');
    }
    p.mudo = !p.mudo; // a confirmação chega no próximo infoDelivery
    pintar(slide);
  }

  // o toque só vale se não foi arrasto: quem passa as fotos com o dedo por cima do vídeo não dispara nada.
  // Mede o quanto o DEDO andou (pointermove), e não a distância entre o aperto e o clique: no iPhone o clique chega
  // corrigido para perto do elemento clicável (a correção de toque do Safari), às vezes a mais de 10 px de onde o dedo
  // encostou, e o toque parado virava "arrasto". Medido no iPhone do Diogo em 20/10/2026: o dedo no ícone de play do
  // 2º vídeo, o clique entregue na capa, e o vídeo não abriu. pointercancel = o iPhone assumiu o gesto (rolagem).
  var gesto = null;
  document.addEventListener(
    'pointerdown',
    function (e) {
      gesto = e.target.closest && e.target.closest('.pl-video-slide') ? { x: e.clientX, y: e.clientY, andou: false } : null;
    },
    true
  );
  document.addEventListener(
    'pointermove',
    function (e) {
      if (gesto && !gesto.andou && Math.abs(e.clientX - gesto.x) + Math.abs(e.clientY - gesto.y) > 10) gesto.andou = true;
    },
    { capture: true, passive: true }
  );
  document.addEventListener(
    'pointercancel',
    function () {
      if (gesto) gesto.andou = true;
    },
    true
  );
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest && e.target.closest('.pl-video-slide__abrir, .pl-video-slide__som');
    if (!alvo) return;
    e.preventDefault();
    var arrastou = !!gesto && gesto.andou;
    gesto = null;
    if (arrastou) return;
    var slide = alvo.closest('.pl-video-slide');
    if (alvo.classList.contains('pl-video-slide__som')) {
      alternarSom(slide);
      return;
    }
    if (!TOQUE) {
      // computador: o modal de sempre, pelo gatilho escondido do slide (modal-button da agência)
      var gatilho = slide.querySelector('.pl-video-slide__gatilho');
      if (gatilho) gatilho.click();
      return;
    }
    if (!slide.plPlayer) {
      montar(slide);
      return;
    }
    // Short: a YouTube desenha o PRÓPRIO alto-falante no canto de cima à direita (com controls=0 também), e ele
    // fica embaixo da camada de toque. Quem toca ali quer o som, não pausar.
    var r = slide.getBoundingClientRect();
    if (e.clientY - r.top < 72 && e.clientX - r.left > r.width * 0.6) alternarSom(slide);
    else tocarOuPausar(slide);
  });

  // O slide que está na tela, pela posição (o mais perto do meio da área da galeria), nunca pela ordem na trilha:
  // com o carrossel em loop (celular, desde 21/10/2026) a agência gira os slides de lugar na página a cada passada, e
  // o número do slide (e.detail.index) deixa de apontar para o filho da trilha. Medido: pela ordem, voltar para o vídeo
  // desmontava o player do próprio slide que estava na tela.
  function slideNaTela(carrossel) {
    var area = carrossel.querySelector('.blaze-track-container') || carrossel;
    var r = area.getBoundingClientRect();
    var meio = r.left + r.width / 2;
    var slides = carrossel.querySelectorAll('.blaze-track > *');
    var melhor = null, distancia = Infinity;
    for (var n = 0; n < slides.length; n++) {
      var q = slides[n].getBoundingClientRect();
      var d = Math.abs(q.left + q.width / 2 - meio);
      if (d < distancia) { distancia = d; melhor = slides[n]; }
    }
    return melhor;
  }

  // saiu do slide do vídeo: pausa já e desmonta quando a passada termina (300 ms de animação).
  // slider-change não sobe (bubbles: false), mas passa pela fase de captura do documento: pega qualquer carrossel,
  // inclusive o que a troca de variante recria. O evento só vem quando o slide muda, então com o vídeo tocando ele
  // significa que o cliente saiu do vídeo; depois da passada, se o vídeo ainda for o slide na tela, não desmonta.
  document.addEventListener(
    'slider-change',
    function (e) {
      var carrossel = e.target;
      if (!atual || !carrossel.contains || !carrossel.contains(atual)) return;
      var slide = atual;
      pausar(slide);
      window.setTimeout(function () {
        if (slide.plPlayer && slideNaTela(carrossel) !== slide) desmontar(slide);
      }, 450);
    },
    true
  );
})();
